@for (cell of cells(); track cell.cls) {
  <div class="td" [class]="cell.cls">
    <div class="layout-column full-width skeleton-cell">
      <bz-skeleton width="80%"></bz-skeleton>
      @if (cell.lines) {
        <bz-skeleton width="55%"></bz-skeleton>
      }
    </div>
  </div>
}
